var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.435 6.435a.8.8 0 1 1 1.13 1.13l-6 6a.8.8 0 0 1-1.13 0l-6-6a.8.8 0 1 1 1.13-1.13L10 11.869z"
})));
SvgChevronDown.displayName = "SvgChevronDown";
export { SvgChevronDown as ReactComponent };
export default SvgChevronDown;